/** Where residents are told to write when only a person can help. */
export const COMMITTEE_EMAIL = 'foresttown.ftra@gmail.com';

/** Who answers that address, for the places worth naming a person. */
export const COMMITTEE_CONTACT_NAME = 'Liz Hilton Gray';

/** Dial string for the same person. Kept unformatted for `tel:` links. */
export const COMMITTEE_PHONE = '0823301398';

/** The same number, spaced the way a South African reads it. */
export const COMMITTEE_PHONE_LABEL = '082 330 1398';
